import {BaseInnerError} from 'tools-ts/src/error/InnerError'

export class TmodelCannotFindPropByIdentifierErr extends BaseInnerError {
    constructor(propIdentifier: string) {
        super(`找不到 identifier 为 '${propIdentifier}' 的属性`);
    }
}

export function cannotFindPropErr(propIdentifier: string): never {
    throw new TmodelCannotFindPropByIdentifierErr(propIdentifier)
}
